import { useRouter } from 'next/router';
import { useEffect } from 'react';
import noScroll from 'no-scroll';

export const useUnlockScrollOnRouteChange = () => {
  const router = useRouter();

  useEffect(() => {
    const unlock = () => {
      noScroll.off();
    };

    router.events.on('routeChangeStart', unlock);

    return () => {
      router.events.off('routeChangeStart', unlock);
    };
  }, [router.events]);
};
